/*
  Shows a sticky banner at the top of the app when the current tab is
  rendering an unsaved admin preview config. Lets the viewer exit.
*/
import { Eye, X } from "lucide-react";
import { isPreviewMode, exitPreview } from "../lib/runtimeConfig";

export default function PreviewBanner() {
  if (!isPreviewMode()) return null;
  return (
    <div
      data-testid="preview-banner"
      className="sticky top-0 z-[60] w-full no-print"
      style={{ background: "var(--accent)", color: "white" }}
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-between gap-4 text-xs sm:text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="h-4 w-4 shrink-0" />
          <span className="truncate font-semibold">Previewing unsaved admin changes</span>
          <span className="hidden sm:inline opacity-85">· visible only to you · expires in 10 min</span>
        </div>
        <button
          onClick={exitPreview}
          data-testid="preview-exit"
          className="inline-flex items-center gap-1 px-2 h-7 rounded-md font-semibold hover:bg-white/15"
        >
          <X className="h-3.5 w-3.5" /> Exit preview
        </button>
      </div>
    </div>
  );
}
